import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-launch-new-book-widget',
	templateUrl: './launch-new-book-widget.component.html',
	styleUrls: ['./launch-new-book-widget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class LaunchNewBookWidgetComponent {
	@Input() author;

	get newInBooksLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/new-in-books`;
	}

	get giveawaysLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/subscriber-surge-giveaways`;
	}

	constructor(
		private as: AnalyticsService,
		private router: Router,
	) {}

	goNewInBooks() {
		const options = {
			section: 5,
			section_headline: 'Build Your Audience',
			tile_placement: 1,
			tile_headline: 'Give your new release its best launch. Books released in the last 90 days are eligible.',
			brand: 'New in Books',
			cta: 'Reserve My Date',
			design_variant: 'Large Logo Header',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.newInBooksLink]);
	}

	goGiveaways() {
		const options = {
			section: 5,
			section_headline: 'Build Your Audience',
			tile_placement: 2,
			tile_headline: 'Grow your Email List',
			brand: 'Subscriber Surge Giveaways',
			cta: 'Join a Giveaway',
			design_variant: 'Large Full Color',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.giveawaysLink]);
	}
}
